// src/config.js
// export const API_URL =
//   process.env.REACT_APP_BACKEND_URL || "https://finance.dev.marsforce.in";

// src/config.js
export const API_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://finance.dev.marsforce.in"
    : "http://localhost:8030");
